import SearchableSelectCustom from '../../../../components/SearchableSelectCustom'
import { CustomerAuthInputField } from './CustomerAuthInputField'
import type { SignupContactStepProps } from './SignupContactStep.types'

type Props = Pick<
  SignupContactStepProps,
  | 'phoneSectionLabel'
  | 'phonePrefixLabel'
  | 'phonePrefixPlaceholder'
  | 'phonePrefixSearchPlaceholder'
  | 'phonePrefixNoResultsLabel'
  | 'phonePrefixOptions'
  | 'phoneNumberLabel'
  | 'phonePlaceholder'
  | 'phonePrefix'
  | 'phoneLocalNumber'
  | 'onPhonePrefixChange'
  | 'onPhoneLocalNumberChange'
  | 'ui'
>

export const SignupContactPhoneSection = ({
  phoneSectionLabel,
  phonePrefixLabel,
  phonePrefixPlaceholder,
  phonePrefixSearchPlaceholder,
  phonePrefixNoResultsLabel,
  phonePrefixOptions,
  phoneNumberLabel,
  phonePlaceholder,
  phonePrefix,
  phoneLocalNumber,
  onPhonePrefixChange,
  onPhoneLocalNumberChange,
  ui,
}: Props) => (
  <section className="space-y-3">
    <h2 className="text-sm font-semibold tracking-tight text-(--color-text-primary)">{phoneSectionLabel}</h2>
    <div className="grid gap-2.5 md:grid-cols-2">
      <label className="grid min-w-0 gap-1 text-sm font-medium text-(--color-text-secondary)">
        <span>
          {phonePrefixLabel}
          {ui.fieldLabelRequiredMark}
        </span>
        <SearchableSelectCustom
          value={phonePrefix}
          onChange={onPhonePrefixChange}
          onBlur={() => ui.onFieldBlur('phonePrefix')}
          ariaLabel={phonePrefixPlaceholder}
          ariaInvalid={Boolean(ui.resolveFieldError('phonePrefix'))}
          describedById={ui.resolveErrorDescribedBy('phonePrefix')}
          placeholder={phonePrefixPlaceholder}
          searchPlaceholder={phonePrefixSearchPlaceholder}
          emptyLabel={phonePrefixNoResultsLabel}
          options={phonePrefixOptions}
          emphasizePrimaryLabel
          buttonClassName={ui.resolveSelectClassName('phonePrefix')}
        />
        {ui.renderFieldHint('phonePrefix')}
      </label>
      <CustomerAuthInputField
        field="phoneLocalNumber"
        label={phoneNumberLabel}
        type="tel"
        value={phoneLocalNumber}
        onChange={onPhoneLocalNumberChange}
        placeholder={phonePlaceholder}
        autoComplete="tel-national"
        inputMode="tel"
        required
        ui={ui}
      />
    </div>
  </section>
)
